import { Unsubscribe } from "firebase/firestore";
import { User } from "../model/User";
import * as firestoreClient from '../script/firestore-client'

const table = 'user'

export async function findFromCache(uuid: string): Promise<User> {
  return await firestoreClient.findFromCache(table, [uuid]) as User
}

export async function save(user: User) {
  await firestoreClient.save(table, user, [user.uuid])
}

export function update(user: User) {
  firestoreClient.save(table, user, [user.uuid])
}

export function watchList(
  cb: (users: User[]) => void,
  filterOps?: firestoreClient.FilterOption[],
  sortOps?: firestoreClient.SortOption[],
  limit?: number,
  changeTypes?: ('added' | 'modified' | 'removed')[]
): Unsubscribe {
  return firestoreClient.watchList(table, data => {
    cb(data as User[])
  }, filterOps, sortOps, limit, changeTypes)
}